import styles from "./app.module.scss";
import Routes from "./routes/Routes";
import { pl as polish } from "date-fns/locale";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { constants } from "./shared/constants";

registerLocale(constants.languageCode, polish);
setDefaultLocale(constants.languageCode);

function App() {
    return (
        <div className={styles.app}>
            <Routes />
        </div>
    );
}

export default App;
